<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="formrow">
    <label class="form-label">Email</label>
    <input type="email" formControlName="email" class="form-control"
      [ngClass]="{ 'is-invalid': submitted && f['email'].errors }" />
    @if (submitted && f['email'].errors) {
      <div class="invalid-feedback">
        @if (f['email'].errors['required']) {
          <div>Email ist Pflicht</div>
        }
      </div>
    }
  </div>
  <div class="formrow">
    <button>
      PASSWORT ZURÜCKSETZEN
    </button>
  </div>
  <div class="formrow">
    <a routerLink="/login">ZURÜCK ZUM LOGIN?</a>
  </div>
</form>